export const fuseNavigationConfig = [
  // {
  //   id: 'applications',
  //   title: 'Applications',
  //   type: 'group',
  //   icon: 'apps',
  //   children: [
  //     {
  //       id: 'example-component',
  //       title: 'Example',
  //       type: 'item',
  //       icon: 'whatshot',
  //       url: '/example',
  //     },
  //     {
  //       id: 'orders',
  //       title: 'Orders',
  //       type: 'item',
  //       icon: 'check_box',
  //       url: '/apps/todo',
  //       badge: {
  //         title: 3,
  //         bg: 'rgb(255, 111, 0)',
  //         fg: '#FFFFFF',
  //       },
  //     },
  //     {
  //       id: 'products',
  //       title: 'Products',
  //       type: 'item',
  //       icon: 'shopping_cart',
  //       url: '/products',
  //     },
  //     {
  //       id: 'settings',
  //       title: 'Settings',
  //       type: 'item',
  //       icon: 'shopping_cart',
  //       url: '/settings',
  //     },
  //   ],
  // },
]



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseNavigationConfig.js